
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.8769 6.27564C20.277 6.6564 20.2926 7.28938 19.9119 7.68942L10.394 17.6894C10.2053 17.8876 9.94368 17.9999 9.67004 18C9.39641 18.0001 9.13468 17.8881 8.94585 17.6901L4.08875 12.5957C3.70764 12.196 3.72273 11.563 4.12245 11.1819C4.52217 10.8008 5.15515 10.8159 5.53626 11.2156L9.66898 15.5502L18.4632 6.31056C18.8439 5.91052 19.4769 5.89488 19.8769 6.27564Z","fill":"#16171F"}})])
          )
        }
      }
    